export default function Hero() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[580px] md:min-h-[650px] flex items-center overflow-hidden bg-background-950"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20cinematic%20atmosphere%20with%20warm%20amber%20and%20deep%20red%20ambient%20lighting%2C%20subtle%20film%20grain%20texture%2C%20abstract%20cinema%20curtain%20drapes%20with%20soft%20spotlight%20glow%2C%20elegant%20theater%20mood%2C%20rich%20dark%20tones%20with%20golden%20accents%2C%20no%20text%2C%20atmospheric%20depth&width=1600&height=900&seq=hero-bg-2026-kk&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/45 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[1400px] mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <p className="inline-block px-3 py-1 mb-4 text-xs font-medium rounded-full bg-primary-500/20 text-primary-300 border border-primary-500/30">
              每日同步更新 · 海量片库秒开
            </p>
            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 leading-tight">
              快看影视
              <br />
              <span className="text-primary-400">电视剧全集免费在线观看</span>
            </h1>
            <p className="mt-4 text-base md:text-lg text-background-300 font-medium tracking-wide">
              高清不缓冲 · 流畅秒播 · 好剧看不停
            </p>
            <p className="mt-6 text-sm md:text-base text-background-400/80 leading-relaxed max-w-2xl mx-auto lg:mx-0">
              快看影视专注打造极致追剧体验，汇聚海量电视剧资源，覆盖古装、悬疑、都市、韩剧、美剧等全品类内容。
              高清画质搭配智能CDN加速，打开即看无需等待，每日同步更新最新剧集，追剧不迷路，好剧一网打尽。
              当前热播《长相思》《长风渡》《莲花楼》等热门大剧均已全集上线，随时随地畅享流畅观影。
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-4 md:gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span className="text-sm text-background-300">日更 50+ 剧集</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span className="text-sm text-background-300">10000+ 片库</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span className="text-sm text-background-300">1080P 高清</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#media"
                onClick={(e) => handleClick(e, '#media')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-base transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-lg"></i>
                开始观看
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleClick(e, '#ranking')}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 rounded-full border border-background-300/30 hover:border-background-300/60 text-background-200 hover:text-background-50 font-medium text-base transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热播榜单
              </a>
            </div>
          </div>

          <div className="w-full lg:w-[420px] xl:w-[480px] flex-shrink-0">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] lg:aspect-[3/4]">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20Chinese%20period%20drama%20cinematic%20poster%20collage%2C%20beautiful%20hanfu%20costume%20characters%20in%20soft%20dramatic%20lighting%2C%20ancient%20Chinese%20architecture%20and%20landscape%20backdrop%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20film%20poster%20aesthetic%2C%20rich%20textures%2C%20no%20text%20overlay&width=800&height=1000&seq=hero-poster-kk-01&orientation=portrait"
                alt="快看影视热门剧集推荐"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4">
                <p className="text-background-50 text-sm font-medium bg-black/30 backdrop-blur-sm rounded-lg px-3 py-2 inline-block">
                  热播推荐 · 每日更新
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}